import React, { ReactNode } from 'react';
import { User } from '../managers/UserManager';
import { UserRole, ValidUserRoles } from './UserRoles';

type AccessOperation = 'any' | 'all';

interface UserAccessProps {
  user?: User | null;
  roles: UserRole[];
  operation?: AccessOperation;
  ownerId?: string;
  children: ReactNode;
  fallback?: ReactNode;
}

const extractValidRoles = (rawRoles?: string[]): UserRole[] =>
  (rawRoles ?? []).filter(
    (r): r is UserRole => typeof r === 'string' && ValidUserRoles.includes(r as UserRole)
  );

const UserAccess: React.FC<UserAccessProps> = ({
  user,
  roles,
  operation = 'all',
  ownerId,
  children,
  fallback = null,
}) => {
  const userRoles: UserRole[] = extractValidRoles(user?.roles);

  const hasRoleAccess =
    operation === 'any'
      ? roles.some(role => userRoles.includes(role))
      : roles.every(role => userRoles.includes(role));

  const isOwner = ownerId && user?.userId === ownerId;

  const hasAccess = hasRoleAccess || isOwner;

  return hasAccess ? <>{children}</> : <>{fallback}</>;
};

export default UserAccess;
